import React from "react";
import ReactCodeInput from "react-verification-code-input";
import styled from "styled-components";
import { StyledLabel, StyledRequired } from "./styles";

const StyledInputVerificationCode = styled(ReactCodeInput)`
    width: 100% !important;

    .styles_react-code-input__CRulA {
        display: flex;
        flex-direction: ${(props) =>
            props.type === "text" && props.isArabic ? "row-reverse" : ""};
        justify-content: ${(props) => (props.type === "text" && props.isArabic ? "flex-end" : "")};
        gap: 7px;
    }

    input {
        background-color: #ffffff !important;
        border: 1px solid #1322951a !important;
        border-radius: 6px;
        flex: 1;
        width: 0px !important;
        max-width: ${(props) => (props.isArabic ? "42px !important" : "28px !important")};
        border: ${(props) => props.errorMessage && "1px solid #bd271e !important"};
    }
    input:disabled {
        background-color: rgba(171, 180, 196, 0.2) !important;
    }
    .styles_react-code-input__CRulA > input:focus {
        caret-color: #1a1c21;
    }

    @media only screen and (max-width: 768px) {
        .styles_react-code-input__CRulA {
            gap: 5px;
        }
    }
`;
const ErrorMessage = styled.p`
    color: #bd271e;
    font-weight: 400;
    font-size: 12px;
    margin-top: 4px;
`;
const ErrorLabel = styled(StyledLabel)`
    color: #bd271e;
`;

function FixedDigitsInput({
    label,
    fields,
    placeholder,
    required,
    onChange,
    value,
    errorMessage,
    onComplete,
    type,
    isArabic,
    name,
    disabled,
    autoFocus,
}) {
    const customProps = {
        autoFocus,
        fields,
        placeholder: new Array(fields).fill(placeholder),
        fieldHeight: 40,
        onChange,
        values: value,
        errorMessage,
        onComplete,
        type,
        isArabic,
        name,
        disabled,
    };
    return (
        <div style={{ width: "100%" }}>
            {errorMessage ? (
                <ErrorLabel>
                    {label} {required && <StyledRequired>*</StyledRequired>}
                </ErrorLabel>
            ) : (
                <StyledLabel>
                    {label} {required && <StyledRequired>*</StyledRequired>}
                </StyledLabel>
            )}
            <StyledInputVerificationCode {...customProps} />
            {errorMessage && <ErrorMessage>{errorMessage}</ErrorMessage>}
        </div>
    );
}

export default FixedDigitsInput;
